/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type { TelegramGeoControllerGetCapitalWithoutCountryIdQueryResponse } from '../types/TelegramGeoControllerGetCapitalWithoutCountryId.ts';

function getTelegramGeoGetCapitalWithoutCountryIdUrl() {
  const res = { method: 'GET', url: `/api/telegram/geo/capital` as const };
  return res;
}

/**
 * {@link /api/telegram/geo/capital}
 */
export async function telegramGeoGetCapitalWithoutCountryId(
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    TelegramGeoControllerGetCapitalWithoutCountryIdQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({ method: 'GET', url: getTelegramGeoGetCapitalWithoutCountryIdUrl().url.toString(), ...requestConfig });
  return res.data;
}
